export default __webpack_public_path__ + "static/media/chart2.09b0c748.svg";